import React from "react";
import config from "../config";

interface ErrorBoundaryState {
	hasError: boolean;
	error: Error | null;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, ErrorBoundaryState> {
	constructor(props: React.PropsWithChildren<{}>) {
		super(props);
		this.state = {hasError: false, error: null};
	}

	static getDerivedStateFromError(error: Error) {
		return {hasError: true, error};
	}

	static getDerivedStateFromErr(error: Error): ErrorBoundaryState {
		return {hasError: true, error};
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		// Only log errors in local environment
		if (config.environment === "dev") {
			// eslint-disable-next-line no-console
			console.error(error, errorInfo);
		}
	}

	render() {
		if (this.state.hasError) {
			return <div>Something went wrong.</div>;
		}
		return this.props.children;
	}
}
